export default "__VITE_ASSET__I77ntrgH__"